module.exports = __webpack_public_path__ + "img/popup-cart-category-sp.076093e4.png";